/**
 * Shared constants and helpers for field change/blur handling.
 * Used by template-specific field handlers and useFieldHandlers dispatcher.
 */

export const GLOBAL_FIELDS = [
  'contracts',
  'contractsData',
  'supplierName',
  'analysisDate',
  'targetLaunchDate',
  'analysisType',
  'productName',
  'analystName',
] as const;

export const PROGRAMMATIC_FIELDS = ['selectedMfgNdc', 'mfg_ndc', 'gsms_mfg_ndc'] as const;

export function isProgrammaticField(fieldName: string): boolean {
  return (PROGRAMMATIC_FIELDS as readonly string[]).includes(fieldName);
}

export function isGlobalField(fieldName: string): boolean {
  return (GLOBAL_FIELDS as readonly string[]).includes(fieldName);
}

export interface MarkUserChangesDeps {
  hasUserMadeChangesRef: { current: boolean };
  isInitialLoadRef: { current: boolean };
}

/**
 * Mark that user has made changes (for auto-save). Skip for programmatic fields.
 */
export function markUserChangesIfNeeded(
  fieldName: string,
  deps: MarkUserChangesDeps
): void {
  if (isProgrammaticField(fieldName)) return;
  deps.hasUserMadeChangesRef.current = true;
  if (deps.isInitialLoadRef.current) {
    deps.isInitialLoadRef.current = false;
  }
}
